import { render, staticRenderFns } from "./ShopStorePayOrder.vue?vue&type=template&id=04dcd6c7&scoped=true"
import script from "./ShopStorePayOrder.vue?vue&type=script&lang=js"
export * from "./ShopStorePayOrder.vue?vue&type=script&lang=js"
import style0 from "./ShopStorePayOrder.vue?vue&type=style&index=0&id=04dcd6c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dcd6c7",
  null
  
)

export default component.exports